import * as tslib_1 from "tslib";
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Cache, Auth } from 'aws-amplify';
import { UserSettingsHttpService } from '../../../../../app/core/user-settings';
import { MatSnackBar } from '@angular/material';
import { MixpanelService } from '../../../../services/mixpanel.service';
import { DemoModeService } from '../../../../../app/core/demo-mode';
import { DevImpersonationService } from '../../../../../app/core/_services/dev-impersonation.service';
import { isOriginalSuperAdminRole } from '../../../../../app/core/_services/impersonation-runtime';
import { VoucherDemoModeService } from '../../../../../app/core/vouchers/demo/voucher-demo-mode.service';
import { VOUCHER_DEMO_ACCOUNT_NAME } from '../../../../../app/core/vouchers/demo/voucher-demo.constants';
import { ViewAsScopeService } from '../../../../../app/core/view-as-scope';
import { map } from 'rxjs/operators';
import { formatRoleLabel, PORTAL_VIEW_CLAIM } from '../../../../core/_config/portal-view';
var ProfileComponent = /** @class */ (function () {
    function ProfileComponent(fb, translate, cdr, http, _snackBar, mixePanelService, demoModeService, devImpersonationService, viewAsScopeService, voucherDemoMode) {
        this.fb = fb;
        this.translate = translate;
        this.cdr = cdr;
        this.http = http;
        this._snackBar = _snackBar;
        this.mixePanelService = mixePanelService;
        this.demoModeService = demoModeService;
        this.devImpersonationService = devImpersonationService;
        this.viewAsScopeService = viewAsScopeService;
        this.voucherDemoMode = voucherDemoMode;
        this.region = 'NA';
        this.territory = 'NA';
        // View As scope (super admins only)
        this.viewAsEnabled = false;
        this.viewAsRole = null;
        this.viewAsDistiId = null;
        this.viewAsClientId = null;
        this.viewAsCampusId = null;
        this.distributors = [];
        this.clients = [];
        this.campuses = [];
        this.loadingDistributors = false;
        this.loadingClients = false;
        this.loadingCampuses = false;
        this.savingViewAs = false;
        this.viewAsRoles = [
            { value: 'distiadmin', label: 'Partner Admin' },
            { value: 'clientadmin', label: 'Client Admin' },
            { value: 'campusadmin', label: 'Campus Admin' }
        ];
    }
    ProfileComponent.prototype.ngOnInit = function () {
        this.userObj = Cache.getItem('userAttr');
        //   this.parseRegionAndTerritory();
        this.initForm();
        this.loadViewAsState();
        Auth.currentUserInfo()
            .then(function (info) {
            console.log(info);
        });
        this.mixePanelService.track(this.mixePanelService.PAGE_VIEW);
    };
    Object.defineProperty(ProfileComponent.prototype, "isSuperAdmin", {
        get: function () {
            return this.devImpersonationService.getOriginalRole() === 'sadmin';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfileComponent.prototype, "canToggleRetailAdminDemo", {
        get: function () {
            return this.devImpersonationService.isImpersonationEnabled()
                && isOriginalSuperAdminRole(this.devImpersonationService.getOriginalRole());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfileComponent.prototype, "retailAdminDemoAccountName", {
        get: function () {
            return VOUCHER_DEMO_ACCOUNT_NAME;
        },
        enumerable: true,
        configurable: true
    });
    ProfileComponent.prototype.onRetailAdminDemoChange = function (enabled) {
        if (!this.canToggleRetailAdminDemo || enabled === this.voucherDemoMode.isEnabled()) {
            return;
        }
        if (enabled) {
            this.viewAsScopeService.clearScope();
            this.devImpersonationService.clearToken();
        }
        this.voucherDemoMode.setEnabled(enabled);
        window.location.reload();
    };
    ProfileComponent.prototype.loadViewAsState = function () {
        var scope = this.viewAsScopeService.getScope();
        if (scope && scope.enabled) {
            this.viewAsEnabled = true;
            this.viewAsRole = scope.role;
            this.viewAsDistiId = scope.distiId != null ? scope.distiId : null;
            this.viewAsClientId = scope.clientId != null ? scope.clientId : null;
            this.viewAsCampusId = scope.campusId != null ? scope.campusId : null;
            this.loadViewAsOptions();
        }
    };
    ProfileComponent.prototype.loadViewAsOptions = function () {
        if (this.viewAsRole === 'distiadmin' && this.distributors.length === 0) {
            this.loadDistributors();
        }
        if (this.viewAsRole === 'clientadmin' && this.clients.length === 0) {
            this.loadClients();
        }
        if (this.viewAsRole === 'campusadmin' && this.campuses.length === 0) {
            this.loadCampuses();
        }
    };
    ProfileComponent.prototype.onViewAsEnabledChange = function (enabled) {
        this.viewAsEnabled = enabled;
        if (!enabled) {
            this.viewAsScopeService.clearScope();
            this.viewAsRole = null;
            this.viewAsDistiId = null;
            this.viewAsClientId = null;
            this.viewAsCampusId = null;
            this.distributors = [];
            this.clients = [];
            this.campuses = [];
            window.location.reload();
        }
    };
    ProfileComponent.prototype.onViewAsRoleChange = function (role) {
        this.viewAsRole = role;
        this.viewAsDistiId = null;
        this.viewAsClientId = null;
        this.viewAsCampusId = null;
        this.clients = [];
        this.campuses = [];
        if (role === 'distiadmin') {
            this.loadDistributors();
        }
        else if (role === 'clientadmin') {
            this.loadClients();
        }
        else if (role === 'campusadmin') {
            this.loadCampuses();
        }
        this.cdr.detectChanges();
    };
    ProfileComponent.prototype.loadDistributors = function () {
        var _this = this;
        this.loadingDistributors = true;
        this.http.getDistis()
            .pipe(map(function (distis) {
            return distis.map(function (d) { return (tslib_1.__assign({ value: String(d.disti_id), label: d.name }, d)); });
        }))
            .subscribe(function (distis) {
            _this.distributors = distis;
            _this.loadingDistributors = false;
            _this.cdr.detectChanges();
        }, function () {
            _this.loadingDistributors = false;
            _this.cdr.detectChanges();
        });
    };
    ProfileComponent.prototype.loadClients = function () {
        var _this = this;
        this.loadingClients = true;
        var params = {};
        if (this.viewAsDistiId) {
            params.disti_id = this.viewAsDistiId;
        }
        this.http.getClients(params)
            .pipe(map(function (clients) {
            return clients.map(function (c) { return (tslib_1.__assign({ value: String(c.client_id), label: c.company_name }, c)); });
        }))
            .subscribe(function (clients) {
            _this.clients = clients;
            _this.loadingClients = false;
            _this.cdr.detectChanges();
        }, function () {
            _this.loadingClients = false;
            _this.cdr.detectChanges();
        });
    };
    ProfileComponent.prototype.loadCampuses = function () {
        var _this = this;
        this.loadingCampuses = true;
        var params = {};
        if (this.viewAsClientId) {
            params.client_id = this.viewAsClientId;
        }
        if (this.viewAsDistiId) {
            params.disti_id = this.viewAsDistiId;
        }
        this.http.getCampus(params)
            .pipe(map(function (campuses) {
            return campuses.map(function (c) { return (tslib_1.__assign({ value: String(c.campus_id), label: c.name }, c)); });
        }))
            .subscribe(function (campuses) {
            _this.campuses = campuses;
            _this.loadingCampuses = false;
            _this.cdr.detectChanges();
        }, function () {
            _this.loadingCampuses = false;
            _this.cdr.detectChanges();
        });
    };
    ProfileComponent.prototype.onViewAsDistiChange = function (distiId) {
        this.viewAsDistiId = distiId;
        this.viewAsClientId = null;
        this.viewAsCampusId = null;
        this.campuses = [];
        if (this.viewAsRole === 'clientadmin' || (distiId && this.viewAsRole === 'campusadmin')) {
            this.loadClients();
        }
        if (distiId && this.viewAsRole === 'campusadmin') {
            this.loadCampuses();
        }
        this.cdr.detectChanges();
    };
    ProfileComponent.prototype.onViewAsClientChange = function (clientId) {
        this.viewAsClientId = clientId;
        this.viewAsCampusId = null;
        if (clientId && this.viewAsRole === 'campusadmin') {
            this.loadCampuses();
        }
        this.cdr.detectChanges();
    };
    ProfileComponent.prototype.saveViewAs = function () {
        var _this = this;
        if (!this.viewAsScopeService.canEnable()) {
            return;
        }
        if (!this.viewAsEnabled || !this.viewAsRole) {
            this.viewAsScopeService.clearScope();
            window.location.reload();
            return;
        }
        var distiMatch = this.viewAsRole === 'distiadmin' && this.viewAsDistiId
            ? this.distributors.find(function (d) { return d.value === _this.viewAsDistiId; }) : null;
        var clientMatch = this.viewAsRole === 'clientadmin' && this.viewAsClientId
            ? this.clients.find(function (c) { return c.value === _this.viewAsClientId; }) : null;
        var campusMatch = this.viewAsRole === 'campusadmin' && this.viewAsCampusId
            ? this.campuses.find(function (c) { return c.value === _this.viewAsCampusId; }) : null;
        var scope = {
            enabled: true,
            role: this.viewAsRole,
            distiId: this.viewAsRole === 'distiadmin' ? this.viewAsDistiId : null,
            clientId: this.viewAsRole === 'clientadmin' ? this.viewAsClientId : null,
            campusId: this.viewAsRole === 'campusadmin' ? this.viewAsCampusId : null,
            distiName: distiMatch ? distiMatch.label : null,
            clientName: clientMatch ? clientMatch.label : null,
            campusName: campusMatch ? campusMatch.label : null
        };
        this.savingViewAs = true;
        this.viewAsScopeService.setScope(scope);
        window.location.reload();
    };
    ProfileComponent.prototype.getViewAsDisplayText = function () {
        var scope = this.viewAsScopeService.getScope();
        if (!scope || !scope.enabled || !scope.role) {
            return '';
        }
        var roleObj = this.viewAsRoles.find(function (r) { return r.value === scope.role; });
        var roleLabel = roleObj ? roleObj.label : scope.role;
        var parts = [roleLabel];
        if (scope.distiId) {
            var d = this.distributors.find(function (x) { return x.value === scope.distiId; });
            parts.push(d ? d.label : "Distributor " + scope.distiId);
        }
        if (scope.clientId) {
            var c = this.clients.find(function (x) { return x.value === scope.clientId; });
            parts.push(c ? c.label : "Client " + scope.clientId);
        }
        if (scope.campusId) {
            var c = this.campuses.find(function (x) { return x.value === scope.campusId; });
            parts.push(c ? c.label : "Campus " + scope.campusId);
        }
        return parts.join(' – ');
    };
    ProfileComponent.prototype.initForm = function () {
        this.profileForm = this.fb.group({
            firstName: [this.userObj.given_name || '', Validators.compose([
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(100)
                ])
            ],
            lastName: [this.userObj.family_name || '', Validators.compose([
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(100)
                ])
            ],
            email: [this.userObj.email || '', Validators.compose([
                    Validators.required,
                    Validators.email,
                    Validators.minLength(3),
                    Validators.maxLength(320)
                ]),
            ],
        });
    };
    ProfileComponent.prototype.parseRole = function () {
        if (!this.userObj) {
            return '';
        }
        return formatRoleLabel(this.userObj['custom:role'], this.userObj[PORTAL_VIEW_CLAIM]);
    };
    ProfileComponent.prototype.parseRegionAndTerritory = function () {
        var _this = this;
        if (this.userObj['custom:region_id'] || this.userObj['custom:territory_id']) {
            this.http.getRegTerr(this.userObj['custom:region_id'], this.userObj['custom:territory_id'])
                .subscribe(function (data) {
                console.log(data.region.region);
                if (data) {
                    _this.region = data.region.region;
                    _this.territory = data.territory.territory;
                    _this.cdr.detectChanges();
                }
            });
        }
    };
    ProfileComponent.prototype.updateAttributes = function () {
        var _this = this;
        Auth.currentAuthenticatedUser()
            .then(function (user) {
            Auth.updateUserAttributes(user, {
                email: _this.profileForm.get('email').value,
                family_name: _this.profileForm.get('lastName').value,
                given_name: _this.profileForm.get('firstName').value
            })
                .then(function (value) {
                Auth.currentUserInfo()
                    .then(function (userAttr) {
                    Cache.setItem('userAttr', userAttr.attributes);
                    _this.userObj = userAttr.attributes;
                    _this.showSnackBar('Updated Successfully', 0);
                });
            });
        });
    };
    /**
     * Checking control validation
     *
     * @param controlName: string => Equals to formControlName
     * @param validationType: string => Equals to valitors name
     */
    ProfileComponent.prototype.isControlHasError = function (controlName, validationType) {
        var control = this.profileForm.controls[controlName];
        if (!control) {
            return false;
        }
        var result = control.hasError(validationType) && (control.dirty || control.touched);
        return result;
    };
    ProfileComponent.prototype.showSnackBar = function (message, duration) {
        var _this = this;
        var snackRef = this._snackBar.open(message, 'close');
        if (duration > 0) {
            setTimeout(function () {
                _this._snackBar.dismiss();
            }, duration);
        }
        snackRef.onAction().subscribe(function () {
            _this._snackBar.dismiss();
        });
    };
    return ProfileComponent;
}());
export { ProfileComponent };
